import { useState, useEffect, useMemo } from 'react';

var loadLightbox = function () { return import('./index-15b8c810.js').then(function (module) { return module.lightbox; }); };
var useLightbox = function (sources, options) {
    var _a = useState(null), lightbox = _a[0], setLightbox = _a[1];
    useEffect(function () {
        loadLightbox().then(function (lightbox) { return setLightbox(function () { return lightbox; }); });
    }, []);
    return useMemo(function () { return (lightbox ? lightbox(sources, options) : null); }, [sources, lightbox]);
};

export { useLightbox };
//# sourceMappingURL=index.js.map
